const systemColors = {
  'water-billing': '#059669',
  'property-tax': '#16a34a',
  'business-permit': '#d97706',
  'e-logbook': '#0891b2',
  'rural-health': '#e11d48',
  'civil-registry': '#4f46e5',
  'settings': '#475569'
}

export default systemColors


